<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 4L3 9L8 14" stroke="currentColor" stroke-width="1.5"/>
      <line x1="3.75" y1="9" x2="15" y2="9" stroke="currentColor" stroke-width="1.5"/>
  </svg>
</template>

